'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' });

var SwapVert = function SwapVert(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SwapVert = (0, _pure2.default)(SwapVert);
SwapVert.muiName = 'SvgIcon';

exports.default = SwapVert;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SwapVert.js
// module id = 2912
// module chunks = 0